import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  name: "DeliveryCost",
  data: function data() {
    return {
      freeFee: this.selectedFee ? this.selectedFee.fee === 0 ? true : false : false,
      cost: this.selectedFee ? this.selectedFee.fee.toString().splitNumberFormat().numberFormat() : null
    };
  },
  components: {},
  methods: {
    save: function save() {
      var _this = this;

      var cost = this.cost.splitNumberFormat();
      this.$vs.loading();
      providerApiService.storeOrUpdateProviderPolygon(this.currentProvider.id, this.selectedZone.id, null, cost).then(function (result) {
        _this.$emit("itemAdded", result.resource);

        _this.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });
      }).finally(function () {
        _this.$vs.loading.close();
      });
    },
    update: function update() {
      var _this2 = this;

      var cost = this.cost.splitNumberFormat();

      if (this.freeFee) {
        cost = 0;
      }

      this.$vs.loading();
      providerApiService.storeOrUpdateProviderPolygon(this.currentProvider.id, this.selectedZone.id, this.selectedFee.id, cost, true).then(function (result) {
        _this2.$emit("itemUpdated", result.resource);

        _this2.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });
      }).finally(function () {
        _this2.$vs.loading.close();
      });
    },
    deleteItem: function deleteItem() {
      var _this3 = this;

      this.$vs.loading();
      providerApiService.deleteDeliveryFee(this.currentProvider.id, this.selectedZone.id, this.selectedFee.id).then(function () {
        _this3.$emit("itemDeleted", _this3.selectedFee);

        _this3.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });
      }).finally(function () {
        _this3.$vs.loading.close();
      });
    }
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  }),
  watch: {
    cost: function cost(newValue) {
      this.cost = newValue.toString().splitNumberFormat().numberFormat();
    },
    freeFee: function freeFee(newValue) {
      if (newValue) {
        this.cost = 0;
      }
    }
  },
  props: {
    selectedZone: {
      required: true,
      type: Object
    },
    selectedFee: {
      required: true,
      type: Object
    }
  }
};